import { ScrollViewTransform, ScrollView } from "../ScrollView.js";
import { IScrollViewResize } from "./IScrollViewResize.js";

export class ScrollViewResizeCenter implements IScrollViewResize {
    public getTransform(view: ScrollView, widthBefore: number, heightBefore: number): ScrollViewTransform {
        var local = view.containerToContent(widthBefore * 0.5, heightBefore * 0.5);
        return {
            scale: view.scale,
            x: view.width * 0.5 - local.x * view.scale,
            y: view.height * 0.5 - local.y * view.scale
        };
    }
}